import React from 'react';
export var ModalImage = function (props) {
    var data = props.data;
    return (React.createElement("div", { className: 'str-chat__modal-image__wrapper', "data-testid": 'modal-image' },
        React.createElement("img", { className: 'str-chat__modal-image__image', src: data.source })));
};
